/**
 * Product-page gate for lb_private tickets: hide picker until eligibility passes.
 * Fail-closed: never unlock picker when API says can_book=false or request fails.
 */
(function () {
  'use strict';

  function isPrivateProduct() {
    var cfg = document.getElementById('lb-private-gate-config');
    if (cfg) {
      try {
        var j = JSON.parse(cfg.textContent || '{}');
        if (j.isPrivate) return true;
      } catch (e) { /* ignore */ }
    }
    var body = document.body;
    if (!body) return false;
    if (body.getAttribute('data-lb-private') === '1') return true;
    var tags = body.getAttribute('data-product-tags') || '';
    return tags.indexOf('lb_private') >= 0;
  }

  if (!isPrivateProduct()) return;

  var cfg = {
    proxyBase: '/apps/ladybae-vendor-test',
    listingId: '',
    productId: '',
    loggedIn: false,
    loginUrl: '/account/login'
    // Identity (email/phone) is resolved server-side from the logged-in Shopify
    // account; never send free-typed contact values (prevents pass hijack).
  };
  var cfgEl = document.getElementById('lb-private-gate-config');
  try {
    if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent || '{}'));
  } catch (e) { /* ignore */ }

  var root = document.querySelector('[data-lb-ticket]') || document.querySelector('.lbtk');
  if (!root) return;

  var banner = document.createElement('div');
  banner.id = 'lb-private-gate-banner';
  banner.style.cssText =
    'padding:12px 14px;margin:0 0 12px;border-radius:10px;background:#faf7f8;border:1px solid rgba(139,30,63,.2);font-family:"Noto Sans TC",sans-serif;font-size:14px;line-height:1.55;';
  banner.textContent = '資格限定課：正在驗證報名資格…';
  root.parentNode.insertBefore(banner, root);
  root.style.display = 'none';

  function deny(msg) {
    banner.style.background = '#fff5f5';
    banner.style.borderColor = 'rgba(166,61,61,.35)';
    banner.textContent = msg || '您目前沒有報名此資格限定課的有效通行證。';
    root.style.display = 'none';
  }

  if (!cfg.loggedIn) {
    banner.innerHTML =
      '此為資格限定課，請先<a href="' +
      String(cfg.loginUrl || '/account/login').replace(/"/g, '') +
      '" style="color:#8b1e3f;font-weight:700;">登入</a>並確認資格後再報名。';
    return;
  }

  var qs = window.location.search || '';
  var url =
    String(cfg.proxyBase || '/apps/ladybae-vendor-test').replace(/\/$/, '') +
    '/private/check-eligibility' +
    qs;
  var params = ['expect_private=1'];
  if (cfg.listingId) params.push('listing_id=' + encodeURIComponent(cfg.listingId));
  if (cfg.productId) params.push('product_id=' + encodeURIComponent(cfg.productId));
  url += (url.indexOf('?') >= 0 ? '&' : '?') + params.join('&');

  fetch(url, { credentials: 'same-origin' })
    .then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, j: j };
      });
    })
    .then(function (res) {
      var j = res.j || {};
      // Fail-closed: only unlock when API explicitly allows booking for a private listing.
      if (res.ok && j.ok && j.can_book === true && j.private === true) {
        banner.style.display = 'none';
        root.style.display = '';
        return;
      }
      if (res.ok && j.ok && j.can_book === true && j.private === false) {
        deny('資格驗證異常（非私域回應），已封鎖報名。');
        return;
      }
      deny(j.message || '您目前沒有報名此資格限定課的有效通行證。');
    })
    .catch(function () {
      deny('資格驗證失敗，請稍後再試。');
    });
})();
